import FormattedText from './FormattedText';
import React from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import { can } from '../../../permissions';
import PageHeading from '../../ReusableComponents/PageHeading';
import DefaultButton from '../../ReusableComponents/DefaultButton';
import SectionButtons from '../../ReusableComponents/SectionButtons';
import { usePortal, usePortalContext } from '../hooks';
import { ErrorNotice, Loading } from './Feedback';
import '../../ReusableComponents/ModulePage.css';
import '../../ReusableComponents/GlobalBreadcrumb.css';
import '../portal.css';
export default function PortalLayout({ title, description, children, beforeContent }) {
  const { base, user, faculdade, labels } = usePortal(),
    context = usePortalContext(),
    location = useLocation(),
    history = useHistory();
  const isApplications = location.pathname.includes('/inscricoes'),
    isDetail = location.pathname !== base && location.pathname !== base + '/inscricoes';
  const organizationPage =
    user?.role === 'region_admin' && String(user?.empresa?.id) !== String(faculdade)
      ? `/organizadoras/edit/${faculdade}`
      : '/minha-organizadora';
  const items = [
    {
      value: 'selections',
      label: labels.selections,
      description: 'Publicação, cargos e regras de inscrição.',
      icon: 'processos',
      visible: can(user, 'portal_configuracoes'),
    },
    {
      value: 'applications',
      label: 'Inscrições recebidas',
      description: 'Candidatos, documentos e acompanhamento.',
      icon: 'candidatos',
      visible: can(user, 'portal_inscricoes'),
    },
  ];
  const home = can(user, 'portal_configuracoes') ? base : base + '/inscricoes';
  return (
    <>
      <nav className="modern-global-breadcrumb hidethis" aria-label="Navegação estrutural">
        <ol>
          <li>
            <Link to={organizationPage}>{context.data?.organization.name || 'Organizadora'}</Link>
          </li>
          <li>
            <span className="breadcrumb-separator" aria-hidden="true">
              /
            </span>
            {isDetail ? (
              <Link to={home}>Portal de inscrições</Link>
            ) : (
              <strong aria-current="page">Portal de inscrições</strong>
            )}
          </li>
          {isDetail && (
            <li>
              <span className="breadcrumb-separator" aria-hidden="true">
                /
              </span>
              <strong aria-current="page"><FormattedText>{title}</FormattedText></strong>
            </li>
          )}
        </ol>
      </nav>
      <div className="module-page module-details portal-admin">
      <section className="card module-card hidethis">
        <div className="card-body">
          <div className="portal-admin-row">
            <PageHeading
              title={<FormattedText>{title}</FormattedText>}
              description={<FormattedText>{description}</FormattedText>}
              icon={isApplications ? 'members' : 'institutions'}
            />
            <DefaultButton
              text="Voltar"
              bg="secondary"
              to={isDetail ? (isApplications ? base + '/inscricoes' : base) : organizationPage}
            />
          </div>
          {context.data?.organization.name && (
            <p className="text-muted mb-0">{context.data.organization.name}</p>
          )}
        </div>
      </section>
      <section className="card module-card detail-summary hidethis">
        <div className="card-body">
          <h2 className="module-selector-title">Escolha um módulo para gerenciar</h2>
          <SectionButtons
            compact
            variant="modules"
            items={items}
            value={isApplications ? 'applications' : 'selections'}
            onChange={(value) =>
              history.push(value === 'applications' ? base + '/inscricoes' : base)
            }
          />
        </div>
      </section>
      <ErrorNotice error={context.error} />
      {beforeContent}
      {context.isLoading ? <Loading /> : context.data && children}
      </div>
    </>
  );
}
